// FAQ : les mêmes questions qu'avant, en accordéon (une seule réponse ouverte).
import React, { useState } from "react";
import Tiggy from "../../site/Tiggy";
import { IconePlus } from "../../site/Icones";

const QUESTIONS = [
	{
		q: "L'app fonctionne-t-elle sans connexion ?",
		r: "Oui, GymNote fonctionne entièrement hors ligne. Toutes tes données sont stockées sur ton téléphone, et la synchronisation se fait automatiquement dès que tu retrouves du réseau.",
	},
	{
		q: "Puis-je suivre plusieurs élèves ?",
		r: "Oui. Un compte gratuit suit jusqu'à 3 élèves ; GymNote Pro jusqu'à 100, avec le dashboard coach web. Chaque élève accepte ton invitation depuis son app.",
	},
	{
		q: "Comment fonctionne la synchronisation ?",
		r: "Elle est automatique : elle se déclenche toutes les 10 secondes quand tu es connecté. En cas de conflit, GymNote garde toujours la version la plus récente.",
	},
	{
		q: "Est-ce que mes données sont sauvegardées ?",
		r: "Oui. Tes entraînements, mesures et exercices sont sauvegardés sur nos serveurs sécurisés. Tu peux aussi exporter tes données à tout moment depuis les paramètres.",
	},
	{
		q: "Puis-je annuler mon abonnement à tout moment ?",
		r: "Oui, sans engagement. Tu annules depuis l'app ; la résiliation prend effet à la fin de la période en cours.",
	},
	{
		q: "L'app est-elle disponible sur iOS et Android ?",
		r: "Oui : sur l'App Store (iPhone et iPad) et sur Google Play (Android). L'expérience est la même sur les deux.",
	},
	{
		q: "Comment inviter un élève ?",
		r: "Dans l'app, va dans ton profil puis dans Partenaires, et génère un code d'invitation. Dès que ton élève l'a utilisé, tu as accès à ses séances.",
	},
	{
		q: "Y a-t-il une période d'essai ?",
		r: "Oui : GymNote+ et GymNote Pro s'essaient gratuitement pendant 30 jours, depuis l'app.",
	},
];

export default function Faq() {
	const [ouverte, setOuverte] = useState(null);

	return (
		<section className="gs-section" id="faq" aria-labelledby="gs-faq-titre">
			<div className="gs-conteneur gs-faq">
				<div className="gs-faq-tete">
					<Tiggy pose="reflexion" taille={150} />
					<span className="gs-surtitre">FAQ</span>
					<h2 id="gs-faq-titre" className="gs-h2">
						Tes questions, nos réponses.
					</h2>
					<p className="gs-texte">Tout ce que tu veux savoir avant de te lancer.</p>
				</div>
				<div className="gs-faq-liste">
					{QUESTIONS.map((item, i) => {
						const estOuverte = ouverte === i;
						return (
							<div key={item.q} className="gs-carte gs-faq-item" data-ouvert={estOuverte}>
								<button
									type="button"
									className="gs-faq-question"
									aria-expanded={estOuverte}
									aria-controls={`gs-faq-r${i}`}
									onClick={() => setOuverte(estOuverte ? null : i)}
								>
									<span>{item.q}</span>
									<span className="gs-faq-signe">
										<IconePlus taille={16} />
									</span>
								</button>
								<div className="gs-faq-reponse" id={`gs-faq-r${i}`}>
									<div>
										<p>{item.r}</p>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
}
